import React from 'react';

import http from 'api/http';
import { systemAPI } from 'api/requests';

import System from './System';
import AdditionalSection from './AdditionalSection';
import CombinationSection from './CombinationSection';
import Button, { buttonColor } from 'Components/Button';
import { STEP_ID } from 'constants/boatApplication';

export default class BoatSystems extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSystemIndex: undefined,
      systemConfigurations: [],
      allComponents: {},
      allSystemsList: [],
      requestInProcess: true
    };
  }

  componentDidMount() {
    http.get(systemAPI.getAvailableBoatSystemsList)
      .then(({data: allSystemsList}) => {
        this.setState({allSystemsList});
      });
  }

  componentDidUpdate() {
    const {allComponents, currentSystemIndex, systemConfigurations} = this.state;
    const {boatSystems} = this.props;

    const requests = [];

    if (boatSystems.length && currentSystemIndex === undefined) {
      for (let system of boatSystems) {
        const ids = [];
        if (system.ruleValueRequests) system.ruleValueRequests.forEach(rule => {
          Object.keys(rule.componentIdWithQuantityMap).forEach(id => {
            if (!ids.find(element => element === id) && !allComponents[id]) {
              ids.push(id);
            }
          });
        });

        requests.push(http.get(systemAPI.getComponent(ids)));
        requests.push(http.get(systemAPI.getBoatSystemStructure(system.componentSystemId)));
      }


      Promise.all(requests)
        .then(result => {
          for (let i = 0, length = result.length; i < length; i++) {
            if (i % 2 === 0) {
              if (result[i].data.length) {
                result[i].data.forEach(component => {
                  allComponents[component.id] = component;
                });
              }
            } else {
              systemConfigurations.push(result[i]);
            }
          }

          this.setState({allComponents, systemConfigurations, requestInProcess: false});
          this.handleSystemChoose(0);
        });
    }
  }

  handleSystemChoose = currentSystemIndex => {
    this.setState({currentSystemIndex});
  };

  render() {
    const {currentSystemIndex, allComponents, systemConfigurations, allSystemsList, requestInProcess} = this.state;
    const {boatSystems, boatDetailsRequestInProcess} = this.props;

    if (!boatSystems || !boatSystems.length) return null;

    if (boatDetailsRequestInProcess) return null;

    if (requestInProcess) {
      return (
        <section className='scene_section boat-systems-details-section'>
          <header>Boat Systems</header>
          <div className='ect-spinner'>
            <div className='ect-spinner__image' />
          </div>
        </section>
      );
    }

    return (
      <section className='scene_section boat-systems-details-section'>
        <header>Boat Systems</header>
        {this.props.isFinalReview && (
          <Button
            color={buttonColor.planeOrange}
            label='Edit'
            buttonClassName='_height_20 _width_60 _position_absolute _right_130 _font_size_14'
            fontSize={14}
            onClick={() => this.props.goToStep(STEP_ID.ADD_COMPONENTS, true)}
          />
        )}
        <section className='boat-systems-details-section__systems-banners-section final-review'>
          <div className='boat-systems-scene__banners-wrapper'>
            {boatSystems.map((system, index) => (
              <System
                key={system.id}
                isActive={currentSystemIndex === index}
                system={system}
                boatSystems={boatSystems}
                currentSystemIndex={currentSystemIndex}
                allSystemsList={allSystemsList}
                indexKey={index}
                handleSystemChoose={this.handleSystemChoose}
              />
            ))}
          </div>
        </section>
        {boatSystems.map((system, key) => (
          <React.Fragment key={key}>
            <System
              key={system.id}
              isActive
              isPrintable
              system={system}
              boatSystems={boatSystems}
              currentSystemIndex={currentSystemIndex}
              allSystemsList={allSystemsList}
              indexKey={key}
              handleSystemChoose={this.handleSystemChoose}
            />
            <AdditionalSection
              system={system}
              isActive={currentSystemIndex === key}
              currentSystemConfiguration={systemConfigurations[key]}
            />
            <CombinationSection
              system={system}
              isActive={currentSystemIndex === key}
              currentSystemConfiguration={systemConfigurations[key]}
              allComponents={allComponents}
            />
          </React.Fragment>
        ))}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/BoatSystems/index.jsx